import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { TriggersTable } from '../../../../../../../../../features/meta/trigger/triggers-table';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger/')({
  head: () => getPageHead('Triggers'),
  component: ClearingTriggerList,
});

function ClearingTriggerList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TriggersTable audience="clearing-core" />
      </PageLayout.Section>
    </PageLayout>
  );
}
